module.exports = __webpack_public_path__ + "images/arrow-line-yellow@2x-0eda71f63e584d30d1e8c9f6d198fbdc.png";